import { __spreadArrays } from "tslib";
var logLevels = ["error", "warn", "info", "log"];
var console = window.console || {};
console.log =
    console.log ||
        function () {
            return undefined;
        }; // No console log, well - do nothing then...
// Make sure methods for all levels exist.
for (var i = 0; i < logLevels.length; i++) {
    var method = logLevels[i];
    if (!console[method]) {
        console[method] = console.log; // Prefer .log over nothing
    }
}
export default {
    error: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log.apply(this, __spreadArrays([1], args));
    },
    warning: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log.apply(this, __spreadArrays([2], args));
    },
    info: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log.apply(this, __spreadArrays([3], args));
    },
    verbose: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log.apply(this, __spreadArrays([4], args));
    },
    log: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var logLevel = args[0];
        if (logLevel > logLevels.length || logLevel <= 0) {
            logLevel = logLevels.length;
        }
        var now = new Date();
        var time = "[" +
            ("0" + now.getHours()).slice(-2) +
            "h" +
            ("0" + now.getMinutes()).slice(-2) +
            "m" +
            ("0" + now.getSeconds()).slice(-2) +
            "s" +
            ("00" + now.getMilliseconds()).slice(-3) +
            "ms]";
        var method = logLevels[logLevel - 1];
        var newArgs = Array.prototype.splice.call(args, 1);
        var func = Function.prototype.bind.call(console[method], console);
        newArgs.unshift(time);
        func.apply(console, newArgs);
    },
};
//# sourceMappingURL=logger.js.map